import { NavLink, NavLinkProps } from "react-router-dom";
import React, { ReactNode } from "react";
import useButtonTheme, { ButtonTheme } from "../../hooks/useButtonTheme";

export interface LinkButtonProps extends NavLinkProps {
  children: ReactNode;
  disabled?: boolean;
  theme?: ButtonTheme;
}

const LinkButton = ({
  className,
  children,
  disabled,
  theme,
  ...props
}: LinkButtonProps) => {
  const { text, bg, border } = useButtonTheme(disabled ? "disabled" : theme);

  return (
    <NavLink
      className={`${className} ${text} ${bg} ${border} ${
        disabled ? "cursor-not-allowed" : ""
      } inline-block px-6 py-3 text-xs font-medium text-center uppercase transition-all duration-300`}
      style={{
        minWidth: "170px",
      }}
      {...props}
    >
      {children}
    </NavLink>
  );
};

export default LinkButton;
